import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

// Define type of a movement log row (you can adjust as needed)
interface RawMaterialMovementLog {
  movementType: string;
  createdDate: string;
  rawMaterialName: string;
  quantity: number;
  vendorName:string;
  invoiceNumber:string;
  sourceType: string;
  sourceValue: string | null;
  documentDetails: string;
  note: string;
}
interface MovementLogTableProps {
  data: RawMaterialMovementLog[];
  loading: boolean;
}

export const RawMaterialMovementLogTable = ({ data, loading }: MovementLogTableProps) => {
  // Example custom cell for 'type'
  const sortedData = [...data].sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
 const typeBody = (rowData: RawMaterialMovementLog) => {
  let severity: "info" | "success" | "warning" | undefined;

  switch (rowData.movementType) {
    case "Inward":
      severity = "success";
      break;
    case "Outward":
      severity = "info";
      break;
    case "Adjust":
      severity = "warning";
      break;
    default:
      severity = undefined; // Or "info" as fallback
  }

  return <Tag value={rowData.movementType} severity={severity} />;
};


const dateBody = (rowData: RawMaterialMovementLog) => {
  const dt = new Date(rowData.createdDate);
  return dt.toLocaleDateString('en-GB'); // Outputs: 22/07/2025
};

  return (
    <div className="col-12">
      <div className="card border-noround p-2">
        <DataTable
  value={sortedData}
  loading={loading}
  paginator
  rows={10}
  rowsPerPageOptions={[10, 25, 50, 100]}
  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
  currentPageReportTemplate="{first} to {last} of {totalRecords}"
>
          <Column header="Type" body={typeBody} />
          <Column header="Date" body={dateBody} />
          <Column field="rawMaterialName" header="RawMaterial" sortable/>
          <Column field="quantity" header="Quantity" sortable/>
          <Column field="vendorName" header="Vendor" sortable/>
          <Column field="invoiceNumber" header="Invoice Number" sortable/>
          <Column field="sourceType" header="Source Type" sortable/>
          <Column field="sourceValue" header="Source / Reference" sortable/>
          <Column field="documentDetails" header="Document Details" sortable/>
          <Column field="note" header="Note" sortable/>
        </DataTable>
      </div>
    </div>
  );
};
